import { useWindowSize } from '@vueuse/core';
import { computed } from 'vue';

export function useScreenWidth() {
   const { width } = useWindowSize();

   const isSmScreen = computed(() => {
      return width.value < 768;
   });

   const isLgScreen = computed(() => {
      return width.value >= 1024;
   });

   return {
      isSmScreen,
      isLgScreen,
   };
}
